// Calendar dates use UTC internally; the order date is always read in Paris time.
export function easterSunday(year) {
  const a = year % 19, b = Math.floor(year / 100), c = year % 100;
  const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const n = h + l - 7 * m + 114;
  return new Date(Date.UTC(year, Math.floor(n / 31) - 1, n % 31 + 1));
}

export function isWorkingDay(date) {
  if ([0, 6].includes(date.getUTCDay())) return false;
  const key = `${date.getUTCMonth() + 1}-${date.getUTCDate()}`;
  if (['1-1', '5-1', '5-8', '7-14', '8-15', '11-1', '11-11', '12-25'].includes(key)) return false;
  const easter = easterSunday(date.getUTCFullYear());
  return ![1, 39, 50].some(offset => date.getTime() === easter.getTime() + offset * 86400000);
}

export function addWorkingDays(date, count) {
  const result = new Date(date);
  while (count > 0) {
    result.setUTCDate(result.getUTCDate() + 1);
    if (isWorkingDay(result)) count--;
  }
  return result;
}

export function deliveryLabel(now = new Date()) {
  const parts = new Intl.DateTimeFormat('fr-FR', { timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(now);
  const part = type => Number(parts.find(value => value.type === type).value);
  const today = new Date(Date.UTC(part('year'), part('month') - 1, part('day')));
  const first = addWorkingDays(today, 6);
  const estimated = addWorkingDays(today, 12);
  const format = new Intl.DateTimeFormat('fr-FR', { timeZone: 'UTC', day: 'numeric', month: 'short', ...(today.getUTCFullYear() !== estimated.getUTCFullYear() ? { year: 'numeric' } : {}) });
  return 'Livraison sous 5 à 9 jours ouvrés';
}

if (typeof customElements !== 'undefined' && !customElements.get('sacone-delivery-dates')) {
  customElements.define('sacone-delivery-dates', class extends HTMLElement {
    connectedCallback() {
      this.update = () => {
        this.textContent = deliveryLabel();
      };
      this.update();
      this.timer = setInterval(this.update, 60000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
  });
}
